import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const handleQuoteClick = (e) => {
    e.preventDefault();
    
    // If on homepage, scroll to pre-approval section
    if (location.pathname === '/') {
      const element = document.getElementById('pre-approval');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If on subpage, navigate to homepage and scroll to pre-approval
      navigate('/#pre-approval');
      setTimeout(() => {
        const element = document.getElementById('pre-approval');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50 border-b-2 border-[#FF6600]">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_equipease-pro/artifacts/k9cg4lku_3partlogoEE%20%28500%20x%20250%20px%29.png"
              alt="EquipEASE Lease Co."
              className="h-[88px] md:h-[110px] w-auto"
            />
          </Link>
          
          <div className="flex items-center gap-4 md:gap-6">
            {/* Phone Number with Icon */}
            <a 
              href="tel:1-844-250-3273" 
              className="flex items-center gap-2 text-[#333333] hover:text-[#FF6600] transition-colors"
            >
              <svg 
                className="w-5 h-5 md:w-6 md:h-6 text-[#FF6600]" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" 
                />
              </svg>
              <span className="hidden sm:inline font-semibold text-sm md:text-base">1-844-250-EASE</span>
            </a>
            
            {/* Get Pre-Approved Button */}
            <button
              onClick={handleQuoteClick}
              className="bg-[#FF6600] hover:bg-[#FF9933] text-white px-4 md:px-6 py-2 md:py-3 rounded-lg font-semibold text-sm md:text-base transition-colors shadow-md hover:shadow-lg flex items-center gap-2"
            >
              <svg 
                className="w-4 h-4 md:w-5 md:h-5" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" 
                />
              </svg>
              <span className="hidden xs:inline">Get Pre-Approved</span>
              <span className="xs:hidden">Quote</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
